import { gql } from '@apollo/client';

export const VERIFY_USER = gql`
  mutation VerifyUser($email: String!, $code: String!) {
    verifyUser(email: $email, code: $code) {
      success
    }
  }
`;
